import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@environments/environment';
import { BrandingConfig } from 'src/core/interfaces/branding.interfaces';

interface BrandingApiResponse {
  data: BrandingConfig;
}

@Injectable({ providedIn: 'root' })
export class BrandingService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.workflowApiUrl}/tenant/branding`;

  get(companyId: string): Observable<BrandingConfig> {
    return this.http
      .get<BrandingApiResponse>(this.baseUrl, { params: { companyId } })
      .pipe(map((response) => response.data));
  }
}
